import { useCommands } from "@remirror/react";

const CustomToolbar: React.FC = () => {
  const commands = useCommands();

  const handleImageSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const imageUrl = reader.result as string;
        commands.insertImage({ src: imageUrl });
      };
      reader.readAsDataURL(file); // Convert image to data URL
    }
  };

  const handleLink = () => {
    const url = prompt("Enter the link URL:"); // Pre-fill prompt if there's an existing link
    if (url) {
      commands.updateLink({ href: url }); // Add or update the link
    } else {
      commands.removeLink(); // Remove the link if no URL is provided
    }
  };

  return (
    <div className="d-flex gap-8">
      {/* Bold Button */}
      <button
        type="button"
        onClick={() => commands.toggleBold()}
        aria-label="Bold"
      >
        <strong>B</strong>
      </button>

      {/* Italic Button */}
      <button
        type="button"
        onClick={() => commands.toggleItalic()}
        aria-label="Italic"
      >
        <em>I</em>
      </button>

      {/* Underline Button */}
      <button
        type="button"
        onClick={() => commands.toggleUnderline()}
        aria-label="Underline"
      >
        <u>U</u>
      </button>

      {/* Image Button */}
      <button
        type="button"
        onClick={() => document.getElementById("image-selector")?.click()}
        aria-label="Insert Image"
      >
        🖼️
      </button>
      <input
        type="file"
        id="image-selector"
        style={{ display: "none" }}
        accept="image/*"
        onChange={handleImageSelect}
      />

      {/* Link Button */}
      <button type="button" onClick={handleLink} aria-label="Insert Link">
        🔗
      </button>
    </div>
  );
};

export default CustomToolbar;
